import { Component, inject } from '@angular/core';
import {
  ModalService,
  ModalRef,
  WithOnDestroy,
  ModalModule,
  TileV2Module,
  ButtonV2Module,
} from '@schenck/rotec-components';
import { UpsertToolingTaskWizardComponent } from '../upsert-tooling-task-wizard/upsert-tooling-task-wizard.component';
import { UploadTasksModalComponent } from 'src/components';
import { ToolingTaskService } from 'src/services';
import { takeUntil } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';

export enum CreateTaskResponse {
  CreatedTask = 'CreatedTask',
  UploadedTaskList = 'UploadedTaskList',
}

@Component({
  selector: 'ma-choose-tooling-task-option-modal',
  templateUrl: './choose-tooling-task-option-modal.component.html',
  styleUrls: ['./choose-tooling-task-option-modal.component.less'],
  imports: [ModalModule, TileV2Module, ButtonV2Module, TranslatePipe],
})
export class ChooseToolingTaskOptionModalComponent extends WithOnDestroy {
  private readonly modalService = inject(ModalService);
  private readonly taskService = inject(ToolingTaskService);
  private readonly modalRef = inject(ModalRef);

  constructor() {
    super();
  }

  close() {
    this.modalRef.close();
  }

  createNewTask() {
    this.modalService
      .open<void>(UpsertToolingTaskWizardComponent)
      .events$.pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        // if we get in here we know it worked
        this.modalRef.emitAndClose(CreateTaskResponse.CreatedTask);
      });
  }

  uploadTaskList() {
    this.modalService
      .open(UploadTasksModalComponent, this.taskService)
      .events$.pipe(takeUntil(this.onDestroy$))
      .subscribe(() => this.modalRef.emitAndClose(CreateTaskResponse.UploadedTaskList));
  }
}
